
import * as React from 'react';
import Box from '@mui/material/Box';


import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import SendIcon from '@mui/icons-material/Send';
import CloseIcon from '@mui/icons-material/Close';
import AssistantIcon from '@mui/icons-material/Assistant';


import { GoogleGenerativeAI } from "@google/generative-ai";
import loadOrariMesseInfo from './utils'
import { AIHistory } from './AIHistory'


  const apiKey = process.env.REACT_APP_GEMINI_API_KEY ;

  async function makeApiRequest(date) {
    return loadOrariMesseInfo(date);
  }


  // Function declaration, to pass to the model.
  const getOrariMesseDeclaration = {
    name: "getOrariMesseInfo",
    parameters: {
      type: "OBJECT",
      description: "Ritorna gli orari delle messe di un dato giorno",
      properties: {
        date: {
          type: "string",
          description: "Data del giorno nel formato yyyy-mm-dd",
        }
      },
      required: ["date"]
    },
  };

  // Executable function code. Put it in a map keyed by the function name
  // so that you can call it once you get the name string from the model.
  const functions = {
    getOrariMesseInfo: ( date ) => {
      return makeApiRequest( date )
    }
  };


  /*
 * Install the Generative AI SDK
 *
 * $ npm install @google/generative-ai
 *
 * See the getting started guide for more information
 * https://ai.google.dev/gemini-api/docs/get-started/node
 */

  const currentDate = new Date();
  
  const genAI = new GoogleGenerativeAI(apiKey);
  const model = genAI.getGenerativeModel({
    model: "gemini-2.5-flash",
    systemInstruction: "Oggi è " + currentDate.toISOString().split('T')[0] + ". Sei un assistente che risponde solo riguardo le informazioni sugli orari delle messe e infromazioni sulla casa del volto santo di capodimonte Napoli www.casadelvoltosanto.it. Se non conosci la risposta, rispondi cortesemente che non puoi aiutare e di inviare una mail a voltosantonapoli@gmail.com",
    tools: {
      functionDeclarations: [getOrariMesseDeclaration],
    },
  });
  
  /*const generationConfig = {
    temperature: 1,
    topP: 0.95,
    topK: 64,
    maxOutputTokens: 8192,
    responseMimeType: "text/plain",
  };*/
  
  let chatSession = null;

  async function initAI() {
    chatSession = model.startChat({

      //generationConfig,
   // safetySettings: Adjust safety settings
   // See https://ai.google.dev/gemini-api/docs/safety-settings
      
      history: AIHistory
    });
  }
  
  

  const sendAIMessage = async (message) => {
    const result = await chatSession.sendMessage(message);
    // For simplicity, this uses the first function call found.
    const calls = result.response.functionCalls();


    if (calls && calls.length > 0) {
      const call = calls[0];
      // Call the executable function named in the function call
      // with the arguments specified in the function call and
      // let it call the hypothetical API.
      const date_string = call.args.date + 'T00:00:00'
      const d = new Date(date_string);
      const apiResponse = await functions[call.name](d);

      // Send the API response back to the model so it can generate
      // a text response that can be displayed to the user.
      const result = await chatSession.sendMessage([{functionResponse: {
        name: 'getOrariMesseInfo',
        response: apiResponse
      }}]);
      return result.response.text();
    } else {
      console.log(result.response.text());
      return result.response.text();
    }
  }

  //initAI()




export default function Footer () {

    const [aiInput, setAiInput] = React.useState("")
    const [apiResponse, setApiResponse] = React.useState("")
    const [aiResponseVisible, setAiResponseVisible] = React.useState(false)

    const onAIInputChange = (v) => {
      setAiInput(v.target.value)
      if (aiResponseVisible) {
        setAiResponseVisible(false)
      }
    }


    const onAIsend = async () => {
      if (aiInput.trim() === '') {
        return
      }
      setAiResponseVisible(true)
      setApiResponse("Sto pensando...")
      const res = await sendAIMessage(aiInput)

      setApiResponse(res)
      setAiInput("")
    }


    return(<div>
      <center>Napoli - Via Ponti rossi, 54 - Telefono 0817410746 - voltosantonapoli@gmail.com</center>
        <Box
        component="form"
        position="fixed"
        bottom="0px"
        right="0px"

        sx={{
          '& > :not(style)': { m: 1, width: '25ch' },
        }}
        noValidate
        autoComplete="off"
      >          
        { apiResponse && aiResponseVisible &&
        <Paper id="ai-response-message-body" class="messagesBody">
          <IconButton color="primary" sx={{ p: '5px', float: 'right' }} aria-label="close" onClick={() => setAiResponseVisible(false)}>
            <CloseIcon />
          </IconButton>
          <InputBase
            multiline={true}
            maxRows={10}
            sx={{ ml: 1, flex: 1, maxHeight: '350px', overflowY: 'auto'}}
            value={apiResponse}
            readOnly={true}
            inputProps={{ 'aria-label': '' }}
          />
        </Paper>
        }
        { false &&
        <Paper
          sx={{ p: '2px 4px', border: 1,display: 'flex', alignItems: 'center', width: 400 }}
        >
          <AssistantIcon />
          <InputBase
            multiline={true}
            sx={{ ml: 1, flex: 1 }}
            placeholder="Domande?"
            value={aiInput}
            onChange={onAIInputChange}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                onAIsend();
              }
            }}
            inputProps={{ 'aria-label': 'search google maps' }}
          />
          <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
          <IconButton color="primary" sx={{ p: '10px' }} aria-label="directions" onClick={onAIsend}>
            <SendIcon />
          </IconButton>
        </Paper>
    }
      </Box>
      </div>)
}
